import React from 'react';
import { I18n } from 'react-redux-i18n-lite';

import CustomIcon from '../../common/CustomIcon';
import CustomReveal from '../../common/reveal/CustomReveal';
import * as pinCodesDownloadService from '../../../services/domain/pinCodesDownloadService';
import { SmartButton } from '../../common/SmartButton';

class GeneratePinCodesAgainReveal extends React.Component {
  static propTypes = {};

  regenerateCodesForce() {
    const { onClose, student, classroom } = this.props;
    pinCodesDownloadService.downloadFileOfStudentOrClassroom(student, classroom);
    onClose();
  }

  render() {
    const { active, onClose, student } = this.props;

    return (
      <CustomReveal id="force-codes" active={active} close={onClose}>
        <div className="parent">
          <div className="header">
            <span className="close-btn" onClick={onClose}>
              <CustomIcon name="close-button" size={24} />
            </span>
            <span className="title">{I18n.t('common.uSure')}</span>
          </div>

          <div className="content">
            <div className="text">
              {student ? `${student.name} ${student.surname} ` : ''}
              {I18n.t('classroomSettings.codesLost')}
            </div>
          </div>

          <div className="footer">
            <div className="footer-content">
              <SmartButton id="cancel-button" onClick={onClose}>
                {I18n.t('common.cancel')}
              </SmartButton>
              <SmartButton id="ok-button" onClick={this.regenerateCodesForce.bind(this)} danger>
                {I18n.t('common.ok')}
              </SmartButton>
            </div>
          </div>
        </div>
      </CustomReveal>
    );
  }
}

export default GeneratePinCodesAgainReveal;
